export const CART_ITEM_KEYS = [
  { label: 'Value', value: 'value' },
  { label: 'Price', value: 'price' },
  { label: 'Discount Price', value: 'discountPrice' },
  { label: 'Sale Price', value: 'salePrice' },
  { label: 'Max Quantity', value: 'quantity' },
  { label: 'Count', value: 'count' },
  { label: 'Is Shippable', value: 'isShippable' },
]
export const TAX_ITEM_KEYS = [
  { key: 'total', label: 'Total Tax' },
  { key: 'totalWithoutTax', label: 'Total Without Tax' },
  { key: 'taxPercent', label: 'Tax Percent' },
  { key: 'taxValue', label: 'Tax Value' },
]

export const ADDRESS_FIELDS = [
  {
    key: 'country',
    label: 'Country',
  },
  {
    key: 'email',
    label: 'Email',
  },
  {
    key: 'firstName',
    label: 'First Name',
  },
  {
    key: 'lastName',
    label: 'Last Name',
  },
  {
    key: 'companyName',
    label: 'Company Name',
  },
  {
    key: 'companyNumber',
    label: 'Company Number',
  },
  {
    key: 'streetAddress',
    label: 'Address',
  },
  {
    key: 'address2',
    label: 'Address 2',
  },
  {
    key: 'city',
    label: 'City',
  },
  {
    key: 'state',
    label: 'State',
  },
  {
    key: 'zip',
    label: 'Zip',
  },
  {
    key: 'phone',
    label: 'Phone',
  },
  {
    key: 'deliveryMethod',
    label: 'Delivery',
  },
  {
    key: 'isDelivery',
    label: 'isDelivery',
  },
]

export const GalleryGridFields = [
  {
    key: 'src',
    label: 'Original',
  },
  {
    key: 'thumbnail',
    label: 'Thumbnail',
  },
  {
    key: 'caption',
    label: 'Caption',
  },
]

export const TextItemsListFields = [
  {
    key: 'text',
    label: 'Label',
  },
  {
    key: 'href',
    label: 'URL',
  },
  {
    key: 'target',
    label: 'Open in',
  },
]

export const TreeViewFields = [
  {
    key: 'value',
    label: 'Value',
  },
  {
    key: 'content',
    label: 'Content',
  },
  {
    key: 'icon',
    label: 'Icon',
  },
]

export const eProductListFields = [
  {
    key: 'value',
    label: 'Value',
  },
  {
    key: 'category',
    label: 'Category',
  },
  {
    key: 'subCategory',
    label: 'Sub Category',
  },
  {
    key: 'image',
    label: 'Image',
  },
  {
    key: 'name',
    label: 'Name',
  },
  {
    key: 'price',
    label: 'Price',
  },
  {
    key: 'discountPrice',
    label: 'Discount Price',
  },
  {
    key: 'isSold',
    label: 'Is Sold Out',
  },
  {
    key: 'isOnSale',
    label: 'On Sale',
  },
  {
    key: 'customTag',
    label: 'Custom Tag',
  },
  {
    key: 'customTagColor',
    label: 'Custom Tag Color',
  },
  {
    key: 'isShippable',
    label: 'Is shippable',
  },
  {
    key: 'quantity',
    label: 'Quantity',
  },
]

export const eCatalogFields = [
  {
    key: 'value',
    label: 'Value',
  },
  {
    key: 'header',
    label: 'Header',
  },
  {
    key: 'icon',
    label: 'Icon',
  },
  {
    key: 'parent',
    label: 'Parent',
  },
]

export const eCatalogFieldsShort = [
  {
    key: 'header',
    label: 'Header',
  },
  {
    key: 'parent',
    label: 'Parent',
  },
]
export const eCouponFields = [
  {
    key: 'value',
    label: 'Value',
  },
  {
    key: 'label',
    label: 'Label',
  },
  {
    key: 'discountNum',
    label: 'Coupon Discount',
  },
  {
    key: 'discountPercent',
    label: 'Coupon Percent Discount',
  },
]

export const eTaxFields = [
  {
    key: 'value',
    label: 'Value',
  },
  {
    key: 'percent',
    label: 'Tax Percent',
  },
]

export const eCartFields = [
  {
    key: 'value',
    label: 'Value',
  },
  {
    key: 'image',
    label: 'Image',
  },
  {
    key: 'name',
    label: 'Name',
  },
  {
    key: 'quantity',
    label: 'Max Quantity',
  },
  {
    key: 'count',
    label: 'Count',
  },
  {
    key: 'price',
    label: 'Price',
  },
  {
    key: 'discountPrice',
    label: 'Discount Price',
  },
  {
    key: 'isSold',
    label: 'Is Sold Out',
  },
  {
    key: 'isOnSale',
    label: 'On Sale',
  },
  {
    key: 'isShippable',
    label: 'Is shippable',
  },
  {
    key: 'attr:0',
    label: 'Attribute 1',
  },
  {
    key: 'attr:1',
    label: 'Attribute 2',
  },
  {
    key: 'attr:2',
    label: 'Attribute 3',
  },
  {
    key: 'attr:3',
    label: 'Attribute 4',
  },
]

export const eProductAttrFields = [
  {
    key: 'value',
    label: 'Value',
  },
  { label: 'Price', key: 'price' },
  { label: 'Discount Price', key: 'discountPrice' },
  {
    key: 'quantity',
    label: 'Quantity',
  },
]

export const eProductAddOnFields = [
  {
    key: 'value',
    label: 'Value',
  },
  {
    key: 'name',
    label: 'Name',
  },
  {
    key: 'src',
    label: 'Image Source',
  },
  {
    key: 'alt',
    label: 'Alternative text',
  },
  { label: 'Price', key: 'price' },
  { label: 'Discount Price', key: 'discountPrice' },
  {
    key: 'quantity',
    label: 'Quantity',
  },
]

export const eProductSlidesFields = [
  {
    key: 'src',
    label: 'Source',
  },
  {
    key: 'alt',
    label: 'Alternative text',
  },
]

export const ExtendedGalleryFields = [
  {
    key: 'title',
    label: 'Title',
  },
  {
    key: 'description',
    label: 'Description',
  },
  {
    key: 'button',
    label: 'Button',
  },
  {
    key: 'image',
    label: 'Image',
  },
  {
    key: 'user',
    label: 'User name',
  },
  {
    key: 'userProfile',
    label: 'User avatar',
  },
]

export const eShippingFields = [
  {
    key: 'value',
    label: 'Id',
  },
  {
    key: 'nameOfMethod',
    label: 'Name of Method',
  },
  {
    key: 'shippingPrice',
    label: 'Shipping Price',
  },
  {
    key: 'businessDays',
    label: 'Business Days',
  },
  {
    key: 'arrivalDate',
    label: 'Arrival Date',
  },
]

export const ImageChoiceFields = [
  {
    key: 'ftListValue',
    label: 'Value',
  },
  {
    key: 'ftListLabel',
    label: 'Image',
  },
]

export const SlackUsersFields = [
  {
    key: 'full_name',
    label: 'Full Name',
  },
  {
    key: 'email',
    label: 'Email',
  },
]

export const UserGroupFields = [
  {
    key: 'id',
    label: 'Id',
  },
  {
    key: 'firstName',
    label: 'First name',
  },
  {
    key: 'lastName',
    label: 'Last Name',
  },
  {
    key: 'email',
    label: 'Email',
  },
]

export const TablePricingFields = [
  {
    key: 'title',
    label: 'Title',
  },
  {
    key: 'id',
    label: 'Id',
  },
  {
    key: 'description',
    label: 'Description',
  },
  {
    key: 'item',
    label: 'Item price',
  },
  {
    key: 'quantity',
    label: 'Quantity',
  },
  {
    key: 'quantityUnit',
    label: 'Quantity Unit',
  },
  // { //no need it's calculated by Item Price * Quantity
  //     key: 'price',
  //     label: 'Price'
  // },
  {
    key: 'groupBy',
    label: 'Group By',
  },
]

export const SchedulerCustomHolidayFields = [
  {
    key: 'ActivityDate',
    label: 'Absence Date',
    type: 'date',
  },
  {
    key: 'StartTime',
    label: 'Start Time',
    type: 'time',
  },
  {
    key: 'EndTime',
    label: 'End Time',
    type: 'time',
  },
  {
    key: 'IsAllDay',
    label: 'All day',
    type: 'boolean',
  },
]

export const SchedulerHolidayFields = [
  {
    label: 'All Day',
    key: 'IsAllDay',
    type: 'boolean',
  },
  {
    label: 'Absence Date',
    key: 'ActivityDate',
    type: 'date',
  },
  {
    label: 'Start Time In Minutes From Midnight',
    key: 'StartTimeInMinutes',
    type: 'int',
  },
  {
    label: 'End Time In Minutes From Midnight',
    key: 'EndTimeInMinutes',
    type: 'int',
  },
  {
    label: 'Recurring Holiday',
    key: 'IsRecurrence',
    type: 'boolean',
  },
  {
    label: 'Recurrence Start',
    key: 'RecurrenceStartDate',
    type: 'date',
  },
  {
    label: 'Recurrence End',
    key: 'RecurrenceEndDateOnly',
    type: 'date',
  },
  {
    label: 'Recurrence Type',
    key: 'RecurrenceType',
    type: 'picklist',
  },
]

export const SchedullerHolidayRecurrenceType = [
  {
    label: 'Recurs Daily',
    value: 'RecursDaily',
  },
  {
    label: 'Recurs Every Weekday',
    value: 'RecursEveryWeekday',
  },
  {
    label: 'Recurs Monthly',
    value: 'RecursMonthly',
  },
  {
    label: 'Recurs Monthly Nth',
    value: 'RecursMonthlyNth',
  },
  {
    label: 'Recurs Weekly',
    value: 'RecursWeekly',
  },
  {
    label: 'Recurs Yearly',
    value: 'RecursYearly',
  },
  {
    label: 'Recurs Yearly Nth',
    value: 'RecursYearlyNth',
  },
]

export const SchedulerCustomHoursFields = [
  {
    key: 'DayOfWeek',
    label: 'Day of Week',
    type: 'picklist',
  },
  {
    key: 'StartTime',
    label: 'Start Time',
    type: 'time',
  },
  {
    key: 'EndTime',
    label: 'End Time',
    type: 'time',
  },
]

export const SchedulerHoursFields = [
  {
    key: 'SundayStartTime',
    label: 'Sunday Start',
    type: 'time',
  },
  {
    key: 'SundayEndTime',
    label: 'Sunday End',
    type: 'time',
  },
  {
    key: 'MondayStartTime',
    label: 'Monday Start',
    type: 'time',
  },
  {
    key: 'MondayEndTime',
    label: 'Monday End',
    type: 'time',
  },
  {
    key: 'TuesdayStartTime',
    label: 'Tuesday Start',
    type: 'time',
  },
  {
    key: 'TuesdayEndTime',
    label: 'Tuesday End',
    type: 'time',
  },
  {
    key: 'WednesdayStartTime',
    label: 'Wednesday Start',
    type: 'time',
  },
  {
    key: 'WednesdayEndTime',
    label: 'Wednesday End',
    type: 'time',
  },
  {
    key: 'ThursdayStartTime',
    label: 'Thursday Start',
    type: 'time',
  },
  {
    key: 'ThursdayEndTime',
    label: 'Thursday End',
    type: 'time',
  },
  {
    key: 'FridayStartTime',
    label: 'Friday Start',
    type: 'time',
  },
  {
    key: 'FridayEndTime',
    label: 'Friday End',
    type: 'time',
  },
  {
    key: 'SaturdayStartTime',
    label: 'Saturday Start',
    type: 'time',
  },
  {
    key: 'SaturdayEndTime',
    label: 'Saturday End',
    type: 'time',
  },
]

export const SchedulerEventsFields = [
  {
    key: 'eventFromTime',
    label: 'From Time',
  },
  {
    key: 'eventMeetingLength',
    label: 'Meeting Length',
  },
  {
    key: 'eventToTime',
    label: 'To Time',
  },
  {
    key: 'isAllDay',
    label: 'All day',
  },
]

export const SchedulerMeetingFields = [
  {
    key: 'value',
    label: 'Value',
  },
  {
    key: 'logo',
    label: 'Logo',
  },
  {
    key: 'name',
    label: 'Name',
  },
  {
    key: 'description',
    label: 'Description',
  },
  {
    key: 'duration',
    label: 'Duration',
  },
]

export const SchedulerFields = [
  {
    key: 'value',
    label: 'Value',
  },
  {
    key: 'IMG_SRC',
    label: 'Avatar',
  },
  {
    key: 'name',
    label: 'Name',
  },
  {
    key: 'heading',
    label: 'Heading',
  },
  {
    key: 'description',
    label: 'Description',
  },
  {
    key: 'fromTime',
    label: 'From Time',
  },
  {
    key: 'toTime',
    label: 'To Time',
  },
]

export const ProductCardFields = [
  {
    key: 'value',
    label: 'Value',
  },
  {
    key: 'name',
    label: 'Product name',
  },
  {
    key: 'image',
    label: 'Product Image',
  },
  {
    key: 'description',
    label: 'Product Description',
  },
]
